<template>
  <div>
    <v-checkbox
      :value="isChecked"
      v-bind="$attrs"
      @click="toggleValue"
      v-on="$listeners"
      :class="{
        'readonly-input': $attrs.readonly
      }"
    >
      <template #label>
        <slot name="label"></slot>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: [Array, String],
      default: () => [],
    },
    val: {
      default: null,
    },
    value: {
      type: Array, 
      default: () => [],
    },
  },

  computed: {
    isChecked() {
      return this.value.includes(this.val);
    },
  },
  methods: {
    toggleValue() {
      const newValue = [...this.value]; // Clone the array
      const index = newValue.indexOf(this.val);
      if (index > -1) {
        newValue.splice(index, 1); // Remove the value if it exists
      } else {
        newValue.push(this.val); // Add the value if it doesn't exist
      }
      this.$emit('input', newValue); // Emit updated array
      console.log("array 1");
      console.log(newValue);
    },
  },
};
</script>

<style scoped>
</style>
